import CompanyCourseStatus, {
  CompanyCourseStatusForm,
  UpdateCompanyCourseStatusForm,
} from "@/interfaces/CompanyCourseStatus";
import CompanyStatus from "@/interfaces/CompanyStatus";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import api from "@/services/api";

export const companyCourseStatusesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyCourseStatuses: build.query<
      IPaginateResponse<CompanyCourseStatus>,
      IFilters
    >({
      query: (params) => ({
        url: `/company-course-statuses`,
        params,
      }),
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyCourseStatuses" as const,
                id,
              })),
              { type: "CompanyCourseStatuses", id: "LIST" },
            ]
          : [{ type: "CompanyCourseStatuses", id: "LIST" }],
    }),
    deleteCompanyCourseStatus: build.mutation<void, string>({
      query: (id) => ({
        url: `/company-course-statuses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "CompanyCourseStatuses", id: "LIST" }],
    }),
    storeCompanyCourseStatus: build.mutation<
      CompanyStatus,
      CompanyCourseStatusForm
    >({
      query: (data) => ({
        url: `/company-course-statuses`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "CompanyCourseStatuses", id: "LIST" }],
    }),
    updateCompanyCourseStatus: build.mutation<
      CompanyStatus,
      [string, UpdateCompanyCourseStatusForm]
    >({
      query: ([id, body]) => ({
        url: `/company-course-statuses/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_, __, [id]) => [{ type: "CompanyCourseStatuses", id }],
    }),
    getCompanyCourseStatus: build.query<CompanyCourseStatus, string>({
      query: (id) => `/company-course-statuses/${id}`,
      providesTags: (result, _error, id) => [
        { type: "CompanyCourseStatuses", id },
      ],
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetCompanyCourseStatusesQuery,
  useDeleteCompanyCourseStatusMutation,
  useUpdateCompanyCourseStatusMutation,
  useStoreCompanyCourseStatusMutation,
  useGetCompanyCourseStatusQuery,
  useLazyGetCompanyCourseStatusesQuery,
} = companyCourseStatusesApi;
